import React from 'react';
import PropTypes from 'prop-types';

import styles from './RacingThemeSearchFilterOption.module.css';

/**
 * Search filter checkbox option.
 */
const RacingThemeSearchFilterOption = props => {
  const {
    label,
    count,
    checked = false,
    name = 'filter',
    onChange,
  } = props;

  return (
    <label className={styles.filterOption}>
      <input
        type="checkbox"
        name={name}
        checked={checked}
        onChange={event => {
          if (typeof onChange === 'function') {
            onChange(event.target.checked);
          }
        }}
        readOnly={typeof onChange !== 'function'}
      />
      {label}
      {typeof count === 'number' ? <span className={styles.filterOptionCount}>{count}</span> : null}
    </label>
  );
};

RacingThemeSearchFilterOption.propTypes = {
  label: PropTypes.string.isRequired,
  count: PropTypes.number,
  checked: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func,
};

export default RacingThemeSearchFilterOption;
